var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"height":"350","width":"450"},on:{"resolve":_vm.save}},[_c('c-form',{ref:"form"},[_c('c-form-item',{attrs:{"label":"渠道图标"}},[_c('c-upload-file',{attrs:{"name":"icon_url","type":"image","size":"1024"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }